import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, LibraryBigIcon } from 'lucide-react';
import { modules } from '../data/modules';
import { totalVolumes } from '../data/offer';
export function ModulesSection() {
  return <section className="bg-navy py-16 sm:py-20" aria-labelledby="modules-title" data-id="element-138" data-mp="1iw32ha07833a">
      <div className="mx-auto max-w-6xl px-4" data-id="element-139" data-mp="1dxjk1jktd9fo">
        <div className="text-center" data-id="element-140" data-mp="1dunizmdo64n0">
          <span className="inline-flex items-center gap-2 rounded-full border border-gold/60 bg-steel px-4 py-2 text-xs font-bold uppercase tracking-[.14em] text-mineral" data-id="element-141" data-mp="2bkiinzv2grg7">
            <LibraryBigIcon className="h-4 w-4" aria-hidden="true" data-id="element-142" data-mp="21lsy1zbscsw9" /> Complete classroom coverage
          </span>
          <h2 id="modules-title" className="mt-4 text-3xl font-extrabold text-white sm:text-4xl" data-id="element-143" data-mp="1wnhprt152qg5">
            The {totalVolumes} Comprehensive Volumes
          </h2>
        </div>

        <div className="mt-10 grid gap-6 lg:grid-cols-2" data-id="element-144" data-mp="l7t18x88ljd8">
          {modules.map((module, index) => {
          const Icon = module.icon;
          return <motion.article key={module.title} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            amount: 0.1
          }} transition={{
            duration: 0.3,
            delay: index % 2 * 0.05,
            ease: [0.23, 1, 0.32, 1]
          }} className="flex flex-col overflow-hidden rounded-xl border border-gold/30 bg-steel shadow-lg shadow-black/20" data-id="element-145" data-mp="1iw0bccre46fg" data-mpi={index}>
                <div className="flex items-center gap-4 border-b border-gold/50 bg-navy-soft px-6 py-5" data-id="element-146" data-mp="14vpi532lyfr4">
                  <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-lg bg-mineral text-navy" data-id="element-147" data-mp="q7mei0c1fg5h">
                    <Icon className="h-6 w-6" aria-hidden="true" data-id="element-148" data-mp="v65yhv72mhv7" />
                  </span>
                  <div data-id="element-149" data-mp="h76fb32buv6f">
                    <p className="text-xs font-bold uppercase tracking-[.14em] text-mineral" data-id="element-150" data-mp="h7zla1tgpgni">Volume {module.number}</p>
                    <h3 className="mt-1 text-lg font-bold leading-tight text-white" data-id="element-151" data-mp="2nu5dyeuoad39">{module.title}</h3>
                  </div>
                </div>

                <div className="flex flex-1 flex-col p-6" data-id="element-152" data-mp="2j2nbfmd044g6">
                  <p className="font-semibold text-white" data-id="element-153" data-mp="2e42kkdjn2x4e">{module.subtitle}</p>

                  <p className="mt-5 text-xs font-bold uppercase tracking-[.12em] text-mineral" data-id="element-154" data-mp="2e1zkt1soppmh">
                    What does it solve in the classroom?
                  </p>
                  <p className="mt-2 text-sm leading-relaxed text-muted" data-id="element-155" data-mp="36s86v4qccu6c">{module.context}</p>

                  <ul className="mt-5 grid flex-1 content-start gap-2" data-id="element-156" data-mp="31ug41fo5rnnd">
                    {module.items.map(item => <li key={item} className="flex gap-2.5 text-sm leading-snug text-white" data-id="element-157" data-mp="2wwoe2r72qblt">
                        <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-mineral" aria-hidden="true" data-id="element-158" data-mp="2svb9sljmqgh0" />
                        {item}
                      </li>)}
                  </ul>

                  <p className="mt-6 rounded-lg border-l-4 border-gold bg-navy/60 p-4 text-sm leading-relaxed text-muted" data-id="element-159" data-mp="1hgft6u1fa4xt">
                    <b className="font-extrabold text-mineral" data-id="element-160" data-mp="x4cmfe6rzke">Result: </b>
                    {module.result}
                  </p>
                </div>
              </motion.article>;
        })}
        </div>

        <div className="mt-8 flex flex-col items-center justify-between gap-4 rounded-xl border border-gold bg-steel px-6 py-6 text-center sm:flex-row sm:text-left" data-id="element-161" data-mp="aoh3p4s5ulpd">
          <p className="text-xs font-bold uppercase tracking-[.16em] text-muted" data-id="element-162" data-mp="kld38l02zxhs">Main collection</p>
          <p className="text-2xl font-extrabold text-white sm:text-3xl" data-id="element-163" data-mp="onghtii1ri7a">
            {totalVolumes} premium volumes <span className="mx-2 text-mineral" data-id="element-164" data-mp="tm1mbu4c0o1j">·</span> Updated for 2026
          </p>
        </div>
      </div>
    </section>;
}